/* eslint-disable no-empty */
import React, { lazy, Suspense, useCallback, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'src/common/refactoredComponents/select/Select';
import { SelectedCurrentLoc } from 'src/pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
const CreateTemplateContainer = lazy(() => import('./CreateTemplateContainer'));
import { getDropdownValues, resetCreateTemplate, clearSingleDropDownList, loadAllPhyscianLoading, getRequiredDataFromOrder, createTemplate, getShipToAddress, setShipToAddressValue } from 'src/pages/scheduleSurgery/redux/actions';
import { getConfigurations } from 'src/common/redux/actions';
import { sizes } from 'src/styles/Media.styled';
import AccountPhysicianTemplate from 'src/pages/scheduleSurgery/components/details/AccountPhysicianTemplate';
import { getObjectFromArray, isIOSiPhoneDevice, getAdditionalTextareaLimit, checkNonTissueExtraItems, debounce, isMobileDevice, logErrorToConsole, checkImpersonationActive, checkProxyActive } from 'src/utils/util';
import { TemplateTitleContainer, TemplateTitle, FooterContainer, OptionalLoadMoreView, AccPhysProceValue, StyledNoOptionMsg, StyledNoFavoriteMsg, StyledSwitchButton } from './CreateTemplate.styled';
import SurgeryFooter from 'src/pages/scheduleSurgery/components/surgery/SurgeryFooter';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { VISIBLE, MANDATORY, pageNames ,TEMPLATES, ALLDISTRICTS, ALLTERRITORIES } from 'src/constants/appConstants';
import { useTranslation } from 'react-i18next';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import moment from 'moment';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import {
    CC_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { accountNumberZeroTrimmer } from 'src/utils/util';

const CreateTemplate = ({
    origin = '',
    orderData: myCaseRef,
    handleClose,
    onOpen = () => {},
    onClose = () => {},
    orderPageMobilePadding,
    footerButtonSize,
    footerButtonMargin,
    orderType,
    templateMandatoryFields,
    createStandardTemplate,
    id = '',
    isFromOrderHistory = false,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let physicianRef = useRef();
    const [filteredAccountList, setFilteredAccountList] = useState([]);
    const [filteredPhysicianList, setFilteredPhycianList] = useState([]);
    const [accountValue, setAccountValue] = useState('');
    const templateNoteStorageKeyRef = useRef(`createTemplateNote:${id || 'default'}`);
    const [templateNote, setTemplateNote] = useState(() => {
        try {
            return sessionStorage.getItem(templateNoteStorageKeyRef.current) || '';
        } catch (e) {
            return '';
        }
    });
    const [templateParams, setTemplateParams] = useState({
        cartData: {},
        templateDetails: {},
        templateUID: '',
    });
    const [accountsObjectList, setAccountsObjectList] = useState([]);
    const [physicianObjectList, setPhysicianObjectList] = useState([]);
    const removedPhysicianIdsRef = useRef(new Set());
    const templateNameStorageKeyRef = useRef(`createTemplateName:${id || 'default'}`);
    const isExplicitCloseRef = useRef(false);
    const rotationInProgressRef = useRef(false);
    const allowBillToAutoPopulateRef = useRef(true);
    const allowShipToAutoPopulateRef = useRef(true);
    const [templateName, setTemplateName] = useState(() => {
        try {
            return sessionStorage.getItem(templateNameStorageKeyRef.current) || '';
        } catch (e) {
            return '';
        }
    });
    const [isFavorite, setFavorite] = useState(false);
    const favoriteOrUnfavorite = () => {
        setFavorite(!isFavorite);
    };
    const [physicianInputValue, setPhysicianValue] = useState('');
    const [templateNotesPopup, setTemplateNotesPopup] = useState(false);
    const [textAreaCharLimit, setTextAreaCharLimit] = useState(4000);
    const [isDataFromOrderAPI, setConsideringDataFromAPI] = useState(false);
    const [extraItems, setExtraItems] = useState([]);
    const [excludedOrderProducts, setExcludedOrderProducts] = useState([]);
    const [templateItemProduct, setTemplateItemProduct] = useState([]);
    const [templateCartProduct, setTemplateCartProduct] = useState([]);
    const [switchToTerritory, setSwitchToTerritory] = useState(true);
    const [showExtraItemNotAvailablePopup, setShowExtraItemNotAvailablePopup] =
        useState(false);
    const [shipToValue, setShipToValue] = useState(null);
    const [shipToInputValue, setShipToInputValue] = useState('');
    const [openShipToDropdown, setOpenShipToDropdown] = useState(false);
    const [billToValue, setBillToValue] = useState('');
    const [billToId, setBillToId] = useState(null);
    const [openBillToDropdown, setOpenBillToDropdown] = useState(false);
    const [careOfValue, setCareOfValue] = useState('');
    const {
        districts,
        districtId,
        territoryId,
        territories,
        accounts,
        accountId,
        physicianId,
        physicians,
        procedures,
        cartProduct,
        surgeryNotes,
        accountsOptionLoading,
        physiciansOptionLoading,
        physicianLoadAllLoading,
        procedureCode,
        createTemplateStore,
        orderTemplateStore,
        territory,
        physicianFieldText,
        physicianName,
        physiciansSelected,
        physicianTextBoxType,
        isMastOrderSurgery,
        billToSelected,
        careOfValueSelected,
        shipToAddressValueSelected
    } = useSelector((state) => ({
        districtId: state.surgeryReducer.surgeryDetails.districtId,
        territoryId: state.surgeryReducer.surgeryDetails.territoryId,
        accountId: state.surgeryReducer.surgeryDetails.accountId,
        accounts: state.detailsDropdownsReducer.accounts.items,
        physicianId: state.surgeryReducer.surgeryDetails.physicianId,
        physicians: state.detailsDropdownsReducer.physicianList.items,
        districts: state.detailsDropdownsReducer.districts.items,
        territories: state.detailsDropdownsReducer.territories.items,
        territory: state.detailsDropdownsReducer.territories,
        procedures: state.detailsDropdownsReducer.procedureList.items,
        cartProduct: state.surgeryReducer.cartData.products,
        surgeryNotes: state.surgeryReducer.notes,
        accountsOptionLoading: state.detailsDropdownsReducer.accounts.loading,
        physiciansOptionLoading:
            state.detailsDropdownsReducer.physicianList.loading,
        procedureCode: state.surgeryReducer.surgeryDetails.procedureCode,
        createTemplateStore: state.productTemplatesReducer.createTemplate,
        physicianLoadAllLoading:
            state.detailsDropdownsReducer.physicianList.physicianLoadAllLoading,
        orderTemplateStore: state.productTemplatesReducer.orderTemplate,
        physicianFieldText:
            state.surgeryReducer.surgeryDetails.physicianFieldText,
        physicianTextBoxType:
            state.surgeryReducer.surgeryDetails.physicianTextBoxType,
         physicianName: 
            state.orderSummaryReducer?.orderBasicDetails?.orderSummaryDetail?.physicianName,
        physiciansSelected: state.productTemplatesReducer.orderTemplate.physiciansSelected,
        isMastOrderSurgery: state?.surgeryReducer?.surgeryDetails?.isMastOrder,
        billToSelected: state.surgeryReducer.surgeryDetails.billToId,
        careOfValueSelected:state.surgeryReducer.shippingDetails.S002.careOfField,
        shipToAddressValueSelected: state.surgeryReducer.shipToAddressValue
    }));
    const removeExtraItem = useSelector(
        (state) => state.loginReducer.removeExtraItem
    );
    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const {
        physicianDropdownSurgeryVisibility,
        physicianDropdownZGSurgeryVisibility,
        physicianTextSurgeryVisibility,
        billToVisibility,
        billToMandatory,
        billToShipToPartnerRole,
        careOfFieldVisibility,
        careOfFieldMandatory,
        shipToVisibility,
        shipToMandatory
    } = useSelector((state) => state.loginReducer);

    const { billToDetails, billToDetailsLoading } = useSelector((state) => ({
        billToDetails: state.detailsDropdownsReducer.billToDetails?.items || [],
        billToDetailsLoading: state.detailsDropdownsReducer.billToDetails?.loading || false,
    }));

    const { shipToAddressSearchResults, shipToAddressSearchLoading } = useSelector((state) => ({
        shipToAddressSearchResults: state.shipToAddressReducer?.shipToAddressSearchResults?.nonTissueAddress || [],
        shipToAddressSearchLoading: state.shipToAddressReducer?.loading || false,
    }));

    const { loadAll } = useSelector((state) => ({
        loadAll: state.detailsDropdownsReducer.physicianList.loadAll,
    }));

    // IMPORTANT: Create Template is an independent form. Keep physician text fields local so
    // editing them in the popup doesn't mutate the underlying Surgery Review & Submit screen.
    const [localPhysicianFieldText, setLocalPhysicianFieldText] = useState(
        physicianFieldText || ''
    );
    const [localPhysicianTextBoxType, setLocalPhysicianTextBoxType] = useState(
        physicianTextBoxType || 'known'
    );

    // Sync localPhysicianFieldText when physiciansSelected becomes available
    useEffectWithErrorLogging(() => {
        if (!localPhysicianFieldText && (physicianFieldText || physicianName || physiciansSelected?.[0]?.name)) {
            setLocalPhysicianFieldText(physicianFieldText || physicianName || physiciansSelected?.[0]?.name);
        }
    }, [physicianFieldText, physicianName, physiciansSelected]);

    const [disableFields, setDisableFields] = useState({
        account: false,
        physician: false,
        physicianTextBox: localPhysicianTextBoxType === 'unknown',
    });
    const [surgeryDate, setSurgeryDate] = useState('');
    const [Procedure, setProcedure] = useState(procedureCode);
    const [physiciantype, setPhysicianType] = useState('favorites');
    const [selectedDistrictId, setSelectedDistrict] = useState(districtId);
    const [selectedTerritoryId, setSelectedTerritory] = useState(territoryId);
    const isDistrictClearedRef = useRef(false);
    const isTerritoryClearedRef = useRef(false);
    const [dropdownHeight, ] = useState('1');
    const [orderDataStatus, setOrderDataStatus] = useState({
        isAccountSet: false,
        isPhysicianSet: false,
        isProcedureSet: false,
        isDistrictSet: false,
        isTerritorySet: false,
        isAccountListFetched: false,
        setProducts: [],
        itemProducts: [],
        districtId: '',
        territoryId: '',
        itemProductsCount: 0,
        setProductsCount: 0,
    });
    const [templateNameErrorMsg, setTemplateNameErrorMsg] = useState(null);

    const date = new Date();
    const employeeRole = checkImpersonationActive() || checkProxyActive()
                    ? sessionStorage.getItem('ProxyUserRole')
                    : getUser();
    const [disablePopup, setDisablePopups] = useState(false);
    const isStandardTemplate =
        employeeRole === CC_USER_ROLE || employeeRole === ITA_USER_ROLE;

    useDynatracePageName((orderTemplateStore.isMastOrder || isMastOrderSurgery)?
        pageNames.mastCreateTemplate: pageNames.surgeryCreateTemplate);
    useEffectWithErrorLogging(() => {
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                accounts: accountId?.accountId ? [accountId.accountId] : [],
                addToFavorite: false,
                districtId: districtId,
                notes: surgeryNotes,
                physicians: physicianId?.physicianId
                    ? [physicianId.physicianId]
                    : [],
                physicianFieldText: physicianFieldText
                    ? physicianFieldText
                    : '',
                procedureCode: procedureCode,
                templateName: '',
                templateType:
                    orderTemplateStore.isMastOrder || isMastOrderSurgery
                        ? 'SURGERY_MAST'
                        : 'surgery',
                territoryId: territoryId,
                isMastOrder:
                    orderTemplateStore.isMastOrder || isMastOrderSurgery,
                isStandardTemplate: isStandardTemplate,
            },
        }));
        accountId && setAccountsObjectList([{ ...accountId }]);
        physicianId && setPhysicianObjectList([{ ...physicianId }]);
        setProcedure(procedureCode);
        return () => {
            try {
                if (isExplicitCloseRef.current || !rotationInProgressRef.current) {
                    sessionStorage.removeItem(templateNameStorageKeyRef.current);
                    sessionStorage.removeItem(templateNoteStorageKeyRef.current);
                }
            } catch (e) {}
            dispatch(resetCreateTemplate());
            setOrderDataStatus({
                isAccountSet: false,
                isPhysicianSet: false,
                isProcedureSet: false,
                isDistrictSet: false,
                isTerritorySet: false,
                isAccountListFetched: false,
                setProducts: [],
                itemProducts: [],
                districtId: '',
                territoryId: '',
                itemProductsCount: 0,
                setProductsCount: 0,
            });
            setTemplateParams({
                cartData: {},
                templateDetails: {},
                templateUID: '',
            });
        };
    }, []);

    useEffectWithErrorLogging(() => {
        if (origin !== 'orders' && origin !== 'calendar') {
            if (switchToTerritory && physicians?.length < 1) {
                physicianTypeChange('Territory');
                setSwitchToTerritory(false);
                handleDisableField('physician', false);
            } else if (switchToTerritory && physicians?.length >= 1) {
                if (physicians?.filter((physician) => physician.physicianId !== physicianId.physicianId)?.length > 0) {
                    setSwitchToTerritory(false);
                } else {
                    if (switchToTerritory) {
                        physicianTypeChange('Territory');
                        setSwitchToTerritory(false);
                        handleDisableField('physician', false);
                    }
                }

            }
        }
    }, [physicians, switchToTerritory]);

    // Auto-switch to Territory when favorites fetch completes with no results,
    // or when the physician list was fetched as 'All' while radio is still on favorites
    useEffectWithErrorLogging(() => {
        if (
            !physiciansOptionLoading &&
            physiciantype === 'favorites' &&
            (accountsObjectList?.length > 0 || accountId?.accountId)
        ) {
            if (physicians?.length === 0) {
                physicianTypeChange('Territory');
                handleDisableField('physician', false);
            } else if (loadAll) {
                const hasFavoritePhysician = physicians?.some(
                    (physician) => physician?.isFavorite === true || physician?.favorite === true
                );
                if (!hasFavoritePhysician) {
                    physicianTypeChange('Territory');
                    handleDisableField('physician', false);
                } else {
                    getPhysicianList({
                        loadAll: false,
                        type: 'Favorites',
                    });
                }
            }
        }
    }, [physicians, physiciansOptionLoading, loadAll]);

    // Re-sync templateName and templateNote on orientation/resize (fixes landscape visibility/reset)
    useEffectWithErrorLogging(() => {
        const syncTemplateName = () => {
            try {
                rotationInProgressRef.current = true;
                const stored = sessionStorage.getItem(templateNameStorageKeyRef.current) || '';
                setTemplateName(stored);
                const storedNote = sessionStorage.getItem(templateNoteStorageKeyRef.current) || '';
                setTemplateNote(storedNote);
            } catch (e) {}
            // allow a short window where rotation is considered in-progress
            setTimeout(() => {
                try {
                    rotationInProgressRef.current = false;
                }
                catch (error) {
                    logErrorToConsole(error);
                }
            }, 800);
        };
        window.addEventListener('orientationchange', syncTemplateName);
        window.addEventListener('resize', syncTemplateName);
        return () => {
            window.removeEventListener('orientationchange', syncTemplateName);
            window.removeEventListener('resize', syncTemplateName);
        };
    }, []);
    useEffectWithErrorLogging(() => {
        getPhysicianList({
            searchValue: '',
            loadAll: false,
            type: physiciantype === 'Territory' ? 'All' : 'favorites',
            sapPartnerId: accountId.accountID,
        });
    }, [accountId]);

    useEffectWithErrorLogging(() => {
        if (origin && myCaseRef) {
            handleFromCalendar();
        }
    }, [myCaseRef]);

    const accountRef= useRef(null);

    const handleInputChange = (name, value) => {
        if (name === 'physicianFieldText') {
            setLocalPhysicianFieldText(value);
            setTemplateParams(prev => ({
                ...prev,
                templateDetails: {
                    ...prev.templateDetails,
                    physicianFieldText: value,
                },
            }));
            return;
        }
        if (name === 'physicianTextBoxType') {
            setLocalPhysicianTextBoxType(value);
            return;
        }
    };
    const physicianTextBoxTypeChange = (type) => {
        handleInputChange('physicianTextBoxType', type);
        setPhysicianValue('');
        if (type === 'unknown') {
            handleInputChange('physicianFieldText', '');
        }
        handleDisableField('physicianTextBox', type === 'unknown');
    };

    const handleFromCalendar = () => {
        if (!districts?.length) {
            dispatch(getDropdownValues({ dropDownName: 'districts' }));
        }
        if (!procedures?.length) {
            dispatch(getDropdownValues({ dropDownName: 'procedureList' }));
        }
        if (!physicians?.length) {
            getPhysicianList({
                searchValue: '',
                loadAll: true,
                sapPartnerId: accountId.accountID,
            });
        }
        setConsideringDataFromAPI(true);
        dispatch(
            getRequiredDataFromOrder({
                isMyCASERef: true,
                MyCASERef: myCaseRef,
                templateType: orderBasicDetails?.currentOrderType || orderType,
                isFromOrderHistory: isFromOrderHistory,
            })
        );
    };

    useEffectWithErrorLogging(() => {
        if (templateMandatoryFields?.expirationField) return;
        if (districts.length > 0) {
            // the order's own districtUID may no longer be one of the current user's
            // assigned districts (eg. cancelled/older order, reassigned territory) -
            // only auto-fall back when there is a single valid district; otherwise
            // leave it empty so the user can choose from the available districts.
            const isOrderDistrictValid =
                orderTemplateStore.districtUID &&
                districts.some(
                    (d) => d.districtCode === orderTemplateStore.districtUID
                );
            const fallbackDistrictId =
                districts.length === 1 ? districts[0].districtCode : '';
            if (!selectedDistrictId && !isDistrictClearedRef.current) {
                setSelectedDistrict(
                    isOrderDistrictValid
                        ? orderTemplateStore.districtUID
                        : fallbackDistrictId
                );
            }
            const districtId = selectedDistrictId
                        ? selectedDistrictId
                        : isOrderDistrictValid
                            ? orderTemplateStore.districtUID
                            : fallbackDistrictId;
            if (districtId) {
                dispatch(
                    getDropdownValues({
                        dropDownName: 'territories',
                        value: districtId === ALLDISTRICTS ? '' : districtId,
                    })
                );
            }
        }
    }, [districts, orderTemplateStore, selectedDistrictId]);

    // Auto-select territory when there's only one available after district change
    useEffectWithErrorLogging(() => {
        if (templateMandatoryFields?.expirationField) return;
        if (territories?.length === 1 && !isDistrictClearedRef.current && !selectedTerritoryId) {
            setSelectedTerritory(territories[0].terrirotryCode);
            isTerritoryClearedRef.current = false;
        }
    }, [territories, selectedDistrictId]);

        // Auto-select billTo when there's only one option available (only on account change)
    useEffectWithErrorLogging(() => {
        if (billToDetails?.length === 1 && !billToId && allowBillToAutoPopulateRef.current) {
            handleBillToChange(billToDetails[0]);
            allowBillToAutoPopulateRef.current = false;
        }
    }, [billToDetails]);


    useEffectWithErrorLogging(() => {
        if (shipToAddressSearchResults?.length > 0 && !shipToValue && allowShipToAutoPopulateRef.current) {
            const target = (orderTemplateStore?.shipToAccount || '')
                .toString()
                .trim();
            const trimmedTarget = accountNumberZeroTrimmer(target);
            const matched = target
                ? shipToAddressSearchResults.find(
                      (item) =>
                          item?.addressId === target ||
                          item?.shippingAddressId === target ||
                          accountNumberZeroTrimmer(item?.addressId || '') ===
                              trimmedTarget ||
                          accountNumberZeroTrimmer(
                              item?.shippingAddressId || ''
                          ) === trimmedTarget
                  )
                : null;
            const defaultShipTo =
                matched ||
                shipToAddressSearchResults.find(item => item.defaultAddress === true);
            if (defaultShipTo) {
                handleShipToChange(defaultShipTo);
                setShipToInputValue(defaultShipTo?.formattedShippingAddressId || defaultShipTo?.accountName || '');
                allowShipToAutoPopulateRef.current = false;
            }
        }
    }, [shipToAddressSearchResults, orderTemplateStore]);

    const filterProducts = (products, itemOnly) => {
        let extraItemAr = [];
        let itemAr = [];
        let productAr = [];
        if (itemOnly) {
            if (products.length > 0) {
                products.map((pr) => {
                    if (checkNonTissueExtraItems(removeExtraItem, pr, true)) {
                        extraItemAr.push(pr);
                    } else {
                        itemAr.push(pr);
                    }
                });
                setExtraItems(extraItemAr);
                setTemplateItemProduct(itemAr);
            }
        } else {
            products?.length > 0 &&
                products.map((pr) => {
                    if (checkNonTissueExtraItems(removeExtraItem, pr, true)) {
                        extraItemAr.push(pr);
                    } else {
                        if (!pr.isSet) {
                            itemAr.push(pr);
                        }
                        productAr.push(pr);
                    }
                });
            setExtraItems(extraItemAr);
            setTemplateItemProduct(itemAr);
            setTemplateCartProduct(productAr);
        }
        
    };

    useEffectWithErrorLogging(() => {
        if (extraItems.length > 0 && !disablePopup) {
            setShowExtraItemNotAvailablePopup(true);
        }
    }, [extraItems]);

    // Surface order-history products that validation flagged as excluded (isExcluded)
    // so the create-template flow informs the user they were not added.
    useEffectWithErrorLogging(() => {
        const excluded = orderTemplateStore?.excludedProducts || [];
        setExcludedOrderProducts(excluded);
        if (excluded.length > 0 && !disablePopup) {
            setShowExtraItemNotAvailablePopup(true);
        }
    }, [orderTemplateStore]);

    const getExtraItemsForPopup = () => {
        if (!excludedOrderProducts.length) {
            return extraItems;
        }
        const seen = new Set(
            extraItems.map((product) => product.productCFN || product.cfn)
        );
        return [
            ...extraItems,
            ...excludedOrderProducts.filter((product) => {
                const key = product.productCFN || product.cfn;
                if (seen.has(key)) {
                    return false;
                }
                seen.add(key);
                return true;
            }),
        ];
    };

    useEffectWithErrorLogging(() => {
        if (
            origin &&
            isDataFromOrderAPI &&
            Object.values(orderTemplateStore).length > 3
        ) {
            // below changes need to remove
            // const abc = {
            //     billToId:"0001008760",
            //     billToName: "㈱第一医療器",
            //     careOf:"kkk",
            //     shipToId: "0001008873",
            //     shipToName: "徳洲会 中部徳洲会病院"
            // }

            // const aaa = {...orderTemplateStore, ...abc}
            const {
                accountsSelected = [],
                physiciansSelected: rawPhysiciansSelected = [],
                itemProductsCount = 0,
                setProductsCount = 0,
                procedureSelected,
                territoryUID,
                districtUID,
                templateType = orderTemplateStore.isMastOrder ||
                    isMastOrderSurgery
                    ? 'SURGERY_MAST'
                    : 'surgery',
                itemProducts,
                setProducts,
                billToId,
                billToName,
                careOfField,
                shipToPartnerId,
                shipToAddressId,
                shipToName
            } = orderTemplateStore;
            const physiciansSelected = rawPhysiciansSelected.filter(
                (ph) => !removedPhysicianIdsRef.current.has(ph?.physicianId)
            );
            if (itemProducts?.length > 0) {
                filterProducts(itemProducts, true);
            }
            if (itemProducts?.length > 0 && setProducts?.length > 0) {
                setTemplateCartProduct([...itemProducts, ...setProducts]);
            } else if (itemProducts?.length > 0) {
                setTemplateCartProduct([...itemProducts]);
            } else if (setProducts?.length > 0) {
                setTemplateCartProduct([...setProducts]);
            }
            let accountsSelectedIds = [];
            let physicianIds = [];
            let currentStatus = Object.assign({}, orderDataStatus);
            if (
                !currentStatus.isAccountSet &&
                accounts?.length &&
                accountsSelected.length
            ) {
                accountsSelectedIds = accountsSelected.map(
                    (ac) => ac?.accountId
                );
                const selectedAccounts = accounts.filter((ac) =>
                    accountsSelectedIds.includes(ac.accountId)
                );
                selectedAccounts?.length &&
                    setAccountsObjectList([...selectedAccounts]);
                currentStatus.isAccountSet = true;
                const obj = {
                    loadAll : true,
                    sapPartnerId: selectedAccounts?.[0]?.accountId,
                    type : physicians?.length < 1 ? 'favorites' : 'All'
                };
                getPhysicianList(obj);
                const physiciansWithFormattedName = physiciansSelected.map(ph => ({
                    ...ph,
                    physicianDisplayName:ph.name
                }));
                setPhysicianObjectList(physiciansWithFormattedName);
                physicianIds = physiciansSelected.map((ph) => ph?.physicianId);
            }
            if (
                !currentStatus.isPhysicianSet &&
                physicians?.length &&
                physiciansSelected.length
            ) {
                physicianIds = physiciansSelected.map((ph) => ph?.physicianId);
                const selectedPhysicians = physicians.filter((phy) =>
                    physicianIds.includes(phy.physicianId)
                );
                const physiciansWithFormattedName = physiciansSelected.map(ph => ({
                    ...ph,
                    physicianDisplayName:ph.name
                }));
                selectedPhysicians?.length ?
                    setPhysicianObjectList([...selectedPhysicians]) : setPhysicianObjectList(physiciansWithFormattedName);
                currentStatus.isPhysicianSet = true;
                if (switchToTerritory && physicians?.length < 1) {
                    physicianTypeChange('Territory');
                    setSwitchToTerritory(false);
                    handleDisableField('physician', false);
                } else if (switchToTerritory && physicians?.length >= 1) {
                    if (physicians?.filter((physician) => physician.physicianId !== physiciansSelected[0]?.physicianId)?.length > 0) {
                        setSwitchToTerritory(false);
                    } else {
                        if (switchToTerritory) {
                            physicianTypeChange('Territory');
                            setSwitchToTerritory(false);
                            handleDisableField('physician', false);
                        }
                    }

                }
            }
            if (!currentStatus.isProcedureSet && procedureSelected) {
                setProcedure(procedureSelected);
                currentStatus.isProcedureSet = true;
            }
             if (!currentStatus.isBillToSet && billToId) {
                const billToSelection = {
                    billToNumber: billToId,
                    billToName: billToName,
                    billToFormattedName: `${billToName} ${accountNumberZeroTrimmer(billToId)}`
                  };
                handleBillToChange(billToSelection);
                currentStatus.isBillToSet = true;
                allowBillToAutoPopulateRef.current = false;
            }
             if (!currentStatus.isCareOfSet && careOfField) {
                const e = { target: { value: careOfField } };
                handleCareOfChange(e);
                currentStatus.isCareOfSet = true;
            }
             if (!currentStatus.isShipToSet && shipToAddressId) {
                 const shipToSelection = {
                    addressId : shipToAddressId,
                    accountName: shipToName,
                    shippingAddressId:shipToPartnerId,
                    formattedShippingAddressId: `${shipToName} ${accountNumberZeroTrimmer(shipToPartnerId)}`
                 };
                 handleShipToChange(shipToSelection);
                currentStatus.isShipToSet = true;
            }
            if (!currentStatus.isDistrictSet && districtUID) {
                // guard against the order's districtUID not being one of the
                // districts the current user has access to (stale/reassigned
                // district on older or cancelled orders). Only auto-select a
                // fallback when the current user has exactly one valid district.
                if (districts?.length > 0) {
                    const isOrderDistrictValid = districts.some(
                        (d) => d.districtCode === districtUID
                    );
                    const fallbackDistrictId =
                        districts.length === 1 ? districts[0].districtCode : '';
                    if (isOrderDistrictValid || fallbackDistrictId) {
                        currentStatus.isDistrictSet = true;
                        setSelectedDistrict(
                            isOrderDistrictValid ? districtUID : fallbackDistrictId
                        );
                    }
                }
            }
            if (!currentStatus.isTerritorySet && territoryUID && !isTerritoryClearedRef.current) {
                if (territories?.length > 0) {
                    currentStatus.isTerritorySet = true;
                    const isOrderTerritoryValid = territories.some(
                        (t) => t.terrirotryCode === territoryUID
                    );
                    if (isOrderTerritoryValid) {
                        setSelectedTerritory(territoryUID);
                    }
                } else if (!districts?.length) {
                    // territories haven't loaded yet (still resolving district) -
                    // leave unresolved so it can retry once they arrive.
                } else {
                    currentStatus.isTerritorySet = true;
                }
            }
            // fetch the account list only ONCE per order - accounts can genuinely
            // come back empty (eg. mismatched/stale district), and re-firing this
            // dispatch on every effect re-run caused an infinite accounts?district=
            // API loop with no result.
            const isOrderDistrictValidForAccountFetch =
                districtUID &&
                districts?.some((d) => d.districtCode === districtUID);
            const districtIdForAccountFetch = selectedDistrictId
                ? selectedDistrictId
                : isOrderDistrictValidForAccountFetch
                    ? districtUID
                    : districts?.length === 1
                        ? districts[0].districtCode
                        : '';
            if (
                districtIdForAccountFetch &&
                accounts.length == 0 &&
                !currentStatus.isAccountListFetched
            ) {
                currentStatus.isAccountListFetched = true;
                getAccountList(
                    {
                        searchValue: '',
                    },
                    districtIdForAccountFetch,
                    territoryUID
                );
            }
            currentStatus.itemProductsCount = templateItemProduct
                ?.filter(
                    (it) =>
                        !it.isSet && removeExtraItem[it.sales0rg] !== 'VISIBLE'
                )
                .reduce(
                    (sum, currentItem) =>
                        sum + parseInt(currentItem.quantity || 0),
                    0
                );
            currentStatus.setProductsCount = setProductsCount;
            currentStatus.itemProducts = templateItemProduct;
            currentStatus.setProducts = orderTemplateStore?.setProducts;
            setOrderDataStatus(currentStatus);
            if (currentStatus.isAccountSet || currentStatus.isPhysicianSet) {
                setTemplateParams(prev => ({
                    ...prev,
                    templateDetails: {
                        ...prev.templateDetails,
                        accounts: prev.templateDetails?.accounts
                            ?.length
                            ? prev.templateDetails?.accounts
                            : accountsSelectedIds?.length
                                ? [...accountsSelectedIds]
                                : [],
                        addToFavorite: false,
                        districtId: districtUID,
                        notes: '',
                        physicians: prev.templateDetails?.physicians
                            ?.length
                            ? prev.templateDetails?.physicians
                            : physicianIds?.length
                                ? [...physicianIds]
                                : [],
                        physicianFieldText: physicianFieldText
                            ? physicianFieldText
                            : '',
                        procedureCode: procedureSelected,
                        templateName: '',
                        templateType: templateType,
                        territoryId: territoryUID,
                    },
                }));
            }
        }
    }, [
        orderTemplateStore,
        districts,
        accounts,
        territories,
        physicians,
        procedures,
    ]);

    useEffectWithErrorLogging(()=>{
        if(careOfValueSelected){
            const e = { target: { value: careOfValueSelected } };
                handleCareOfChange(e);
        }
        if(Object.keys(shipToAddressValueSelected).length > 0){
                 handleShipToChange(shipToAddressValueSelected);
                 allowShipToAutoPopulateRef.current = false;
        }
        if(Object.keys(billToSelected).length > 0){
                handleBillToChange(billToSelected);
                allowBillToAutoPopulateRef.current = false;
        }

    },[billToSelected, careOfValueSelected, shipToAddressValueSelected]);

    useEffectWithErrorLogging(() => {
        if (cartProduct.length > 0) {
            filterProducts(cartProduct, false);
        }
    }, [cartProduct, removeExtraItem]);

    useEffectWithErrorLogging(() => {
        if (templateMandatoryFields?.expirationField) return;
        if (accounts) {
            const filteredAccountList = accounts.filter((it) => {
                if (templateParams?.templateDetails?.accounts) {
                    return !templateParams.templateDetails.accounts.includes(
                        it.accountId
                    );
                }
                return true;
            });
            setFilteredAccountList(filteredAccountList);
        }
        if (physicians) {
            const filteredPhysicianList = physicians.filter((it) => {
                if (templateParams?.templateDetails?.physicians) {
                    return !templateParams.templateDetails.physicians.includes(
                        it.physicianId
                    );
                }
                return true;
            });
            setFilteredPhycianList(filteredPhysicianList);
        }
    }, [accounts, physicians, templateParams]);

    useEffectWithErrorLogging(() => {
        if (createTemplateStore.statusCode == '200') {
            try {
                sessionStorage.removeItem(templateNameStorageKeyRef.current);
            } catch (e) {}
            isExplicitCloseRef.current = true;
            dispatch(resetCreateTemplate());
            handleClose(false);
        }
        if (createTemplateStore.statusCode == '10828') {
            setTemplateNameErrorMsg(createTemplateStore.statusMessage);
            setTemplateNotesPopup(true);
            closekeyBoard();
            dispatch(resetCreateTemplate());
        }
        if (createTemplateStore.statusCode == '10007') {
            setTemplateNameErrorMsg('Territory field is required');
            setTemplateNotesPopup(true);
            closekeyBoard();
            dispatch(resetCreateTemplate());
        }
    }, [createTemplateStore]);

    useEffectWithErrorLogging(()=>{
        dispatch(getConfigurations({
            resourceType: 'visibility',
            module: TEMPLATES,
            orderType: 'ZLC',
            optionChosen:TEMPLATES
        }, TEMPLATES));
    },[]);

    // eslint-disable-next-line no-unused-vars
    const handleAddAccountToTemplate = (value, reason) => {
        if (value) {
            const newAccount = {
                accountId: value.accountId,
                accountName: value.accountName,
            };
            const newAccountsList = [
                ...templateParams.templateDetails.accounts,
                value.accountId,
            ];
            const newAccountsListWithObject = [
                ...accountsObjectList,
                newAccount,
            ];
            setTemplateParams(prev => ({
                ...prev,
                templateDetails: {
                    ...prev.templateDetails,
                    accounts: newAccountsList,
                },
            }));
            setAccountsObjectList(newAccountsListWithObject);

            // Fetch physicians for the newly selected account
            getPhysicianList({
                searchValue: '',
                loadAll: false,
                type: physiciantype === 'Territory' ? 'All' : 'favorites',
                sapPartnerId: value.accountId,
            });

            // Fetch Bill To details when account is selected
            if (billToVisibility === VISIBLE || billToVisibility === MANDATORY) {
                allowBillToAutoPopulateRef.current = true;
                const billToParams = {
                    district: selectedDistrictId || 'ALL_Districts',
                    territory: selectedTerritoryId || 'All_Territories',
                    sapPartnerId: value.accountId,
                    searchValue: '',
                };
                dispatch(
                    getDropdownValues({ dropDownName: 'billToDetails', value: billToParams })
                  );
                }
            }
    };
    const handleAddPhysicianToTemplate = (value) => {
        if (value) {
            if (removedPhysicianIdsRef.current.has(value.physicianId)) {
                return;
            }
            if (
                templateParams?.templateDetails?.physicians?.includes(
                    value.physicianId
                )
            ) {
                return;
            }
            const newPhysician = {
                physicianId: value.physicianId,
                physicianDisplayName: value.physicianDisplayName,
            };
            const newPhysiciansList = [
                ...templateParams.templateDetails.physicians,
                value.physicianId,
            ];
            const newPhysicianListWithObject = [
                ...physicianObjectList,
                newPhysician,
            ];
            setTemplateParams(prev => ({
                ...prev,
                templateDetails: {
                    ...prev.templateDetails,
                    physicians: newPhysiciansList,
                },
            }));
            setPhysicianObjectList(newPhysicianListWithObject);
        }
    };

    const handleRemoveAccountFromTemplate = (event) => {
        const accountIdToRemove = event.target.id;
        const newAccountsList = [
            ...templateParams.templateDetails.accounts,
        ].filter((item) => item !== accountIdToRemove);
        const newAccountsListWithObject = [...accountsObjectList].filter(
            (item) => item.accountId !== accountIdToRemove
        );
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                accounts: newAccountsList,
            },
        }));
        setAccountsObjectList(newAccountsListWithObject);
        clearBillToAndShipTo();
    };

    const handleRemovePhysicianFromTemplate = (event) => {
        const physicianIdToRemove = event.target.id;
        if (physicianIdToRemove) {
            removedPhysicianIdsRef.current.add(physicianIdToRemove);
        }
        const newPhysicianList = [
            ...templateParams.templateDetails.physicians,
        ].filter((item) => item !== physicianIdToRemove);
        const newPhysicianListWithObject = [...physicianObjectList].filter(
            (item) => item.physicianId !== physicianIdToRemove
        );
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                physicians: newPhysicianList,
            },
        }));

        setPhysicianObjectList(newPhysicianListWithObject);
    };

    const getViewWidth = () => {
        switch (window.innerWidth) {
            case sizes.smalDevice:
                return '18vw';
            case sizes.mediumDevice:
                return '20vw';
            case sizes.mobileDevice:
                return '44vw';
            default:
                return '65%';
        }
    };

    const getAddressWidth = () => {
        switch (window.innerWidth) {
            case sizes.smalDevice:
                return '40%';
            default:
                return '48%';
        }
    };

    const AccountTemplate = useCallback((option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                nameWidth={getViewWidth()}
                addressWidth={getAddressWidth()}
                option={option}
                data={fieldname == 'account' ? accounts : physicians}
                optionValue={
                    fieldname == 'account'
                        ? 'accountId'
                        : physicians?.length
                            ? 'physicianId'
                            : ''
                }
                fieldname={fieldname}
                onLoadMore={() => handleLoadAll(true)}
                showLoadMore={!loadAll}
                showOptionLoader={physicianLoadAllLoading}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    }, [accounts, physicians, loadAll, physicianLoadAllLoading]);

    const handleLoadAll = (loadAnimation) => {
        setPhysicianValue('');
        dispatch(loadAllPhyscianLoading(loadAnimation ? loadAnimation : false));
        getPhysicianList({
            searchValue: '',
            loadAll: true,
            sapPartnerId: accountsObjectList[0]?.accountId || accountId.accountID,
        });
    };

    const handleOnfocus = (event, field) => {
        if (field == 'accounts') {
            accountRef?.current?.focus();

            getAccountList({
                searchValue: accountValue?.trim() || '',
            });
        }
    };
    const { salesOrg, userDetailsLoading } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
        userDetailsLoading: state.loginReducer.userDetailsLoading,
    }));

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const userDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    const { sapID } = userDetails;

    const getPhysicianList = (data) => {
        const {sapPartnerId, loadAll, type } = data;
        let params = {
            physicianType: type
                ? type
                : physiciantype == 'favorites'
                    ? 'Favorites'
                    : 'All',
            isLoadAll: loadAll,
            isSurgeryFlow: true,
            searchTerm: physicianInputValue ? physicianInputValue : '',
            sapPartnerId: sapPartnerId ? sapPartnerId : accountsObjectList[0]?.accountId || accountId.accountId || sapID,
        };

        dispatch(
            getDropdownValues({
                dropDownName: 'physicianList',
                value: params,
                salesOrg: salesOrg,
                countryISOCode: countryISOCode,
            })
        );
    };
    const getAccountList = (data, districtIdFromEdit, territoryIdFromEdit) => {
        let params = {
            district: selectedDistrictId
                ? selectedDistrictId
                : districtIdFromEdit,
            territory: selectedTerritoryId
                ? selectedTerritoryId
                : territoryIdFromEdit,
            searchParam: accountValue ? accountValue : '',
        };
        dispatch(
            getDropdownValues({ dropDownName: 'accounts', value: params })
        );
    };

    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;

    const handleSearch = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            let option = {
                searchValue: value,
                sapPartnerId: accountsObjectList[0]?.accountId || accountId.accountID,
            };
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                debouncedGetList(getPhysicianList, option);
            } else if (fieldname == 'account') {
                setAccountValue(value);
                debouncedGetList(getAccountList, option);
            } else if (fieldname == 'billToId') {
                setBillToValue(value);
                debouncedGetList(getBillToDetailsList, option);
            }
        } else {
            if (fieldname == 'physician') {
                setPhysicianValue('');
            } else if (fieldname == 'account') {
                setAccountValue('');
            } else if (fieldname == 'billToId') {
                setBillToValue(value);
            }
        }
    };

    const handleDisableField = (fieldName, value) => {
        setDisableFields({
            ...disableFields,
            [fieldName]: value,
        });
    };

    const userBasedAccountSelection = () => {
        if(billToShipToPartnerRole == 'BILL_TO'){
            return templateParams?.templateDetails?.billToId;
        }else{
            return accountsObjectList[0]?.accountId;
        }
    };

    const clearBillToAndShipTo = () => {
        allowShipToAutoPopulateRef.current = false;
        allowBillToAutoPopulateRef.current = false;
        handleBillToChange(null);
        setBillToValue('');
        setShipToInputValue('');
        handleShipToChange(null);
    };

    const getShipToAddressList = (params) => {
        dispatch(
            getShipToAddress({
                dropdownName: 'shipToAddress',
                searchValue: params?.searchValue || '',
                accountId: params?.accountId || userBasedAccountSelection(),
            })
        );
    };

    const handleShipToChange = (value) => {
        setShipToValue(value);
        //dispatch(setShipToAddressValue(value));
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                shipToAddressId: value?.addressId || '',
                shipToPartnerId: value?.shippingAddressId || '',
            },
        }));
    };

    const handleShipToInputChange = (event, value, reason) => {
        if (reason !== 'reset') {
            setShipToInputValue(value);
            if (value) {
                getShipToAddressList({ searchValue: value });
            }
        }
    };

    const getBillToDetailsList = (data) => {
        const { searchValue = '' } = data;
        let params = {
            district: selectedDistrictId || 'ALL_Districts',
            territory: selectedTerritoryId || 'All_Territories',
            sapPartnerId: accountsObjectList[0]?.accountId,
            searchValue,
        };
        dispatch(
            getDropdownValues({ dropDownName: 'billToDetails', value: params })
        );
    };

    const handleBillToChange = (value) => {
        setBillToId(value);
        setBillToValue(value?.billToName || '');
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                billToId: value?.billToNumber || '',
                billToName: value?.billToName || '',
            },
        }));
        // Enable shipTo auto-population when billTo changes
        if (value) {
            allowShipToAutoPopulateRef.current = true;
        }
        getShipToAddressList({
            searchValue: '',
            accountId: value?.billToNumber ? value.billToNumber : userBasedAccountSelection(),
        });
    };

    const handleCareOfChange = (e) => {
        const val = e.target.value.slice(0, 30);
        setCareOfValue(val);
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                careOfField: val,
            },
        }));
    };

    const physicianTypeChange = (type) => {
        setPhysicianType(type);
        setPhysicianValue('');
        handleDisableField('physician', true);
        dispatch(
            clearSingleDropDownList({
                name: 'physicianList',
            })
        );

        getPhysicianList({
            searchValue: '',
            loadAll: false,
            type: type === 'Territory' ? 'All' : 'favorites',
            sapPartnerId: accountsObjectList[0]?.accountId || accountId.accountID,
        });
    };

    const renderNoOption = (
        <OptionalLoadMoreView
            height={physiciantype == 'Territory' ? '200px' : '158px'}
            maxHeight={
                isMobileDevice()
                    ? 'unset'
                    : physiciantype == 'Territory'
                        ? dropdownHeight
                        : dropdownHeight - 100
            }
        >
            {physiciantype == 'Territory' ? (
                <>
                    <StyledNoOptionMsg>
                        {t('scheduleSurgery.details.notRecetPhysicianMSG')}
                        <br></br>
                        {t(
                            'scheduleSurgery.details.trySearchingByTypeMSG'
                        )}{' '}
                    </StyledNoOptionMsg>
                    <p>
                        {t('scheduleSurgery.details.cantFindWhoYou')}
                        <br></br>
                        {t('scheduleSurgery.details.areLookingFor')}{' '}
                    </p>
                    <button
                        onMouseDown={() => {
                            handleLoadAll(true);
                        }}
                    >
                        {t('scheduleSurgery.details.loadAllPhysicians')}
                    </button>
                </>
            ) : (
                <>
                    <StyledNoFavoriteMsg>
                        {t('scheduleSurgery.details.noFavoritePhysuciansSet')}
                    </StyledNoFavoriteMsg>
                    <StyledSwitchButton
                        onMouseDown={(e) => {
                            e.preventDefault();
                            physicianTypeChange(
                                physiciantype === 'Territory'
                                    ? 'favorites'
                                    : 'Territory',
                                true
                            );
                        }}
                    >
                        {t(
                            'scheduleSurgery.details.switchToTerritoryPhysicians'
                        )}
                    </StyledSwitchButton>
                </>
            )}
        </OptionalLoadMoreView>
    );

    const handleTemplateName = (e) => {
        const val = e?.target?.value ?? '';
        setTemplateName(val);
        try {
            sessionStorage.setItem(templateNameStorageKeyRef.current, val);
        } catch (err) {
            // no-op: storage might be unavailable
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            templateNote &&
            templateNote.length > 0 &&
            getAdditionalTextareaLimit(templateNote) > 0
        ) {
            setTextAreaCharLimit(
                4000 + getAdditionalTextareaLimit(templateNote)
            );
        } else {
            setTextAreaCharLimit(4000);
        }
    }, [templateNote]);

    const handleNote = (note) => {
        const lengthOfNote = note.length;
        if (lengthOfNote <= 4000) {
            setTemplateNote(note);
            try {
                sessionStorage.setItem(templateNoteStorageKeyRef.current, note);
            } catch (e) {}
        } else {
            const sliceLastIdx = 4000 - lengthOfNote;
            setTemplateNote(note.slice(0, sliceLastIdx));
            setTemplateNotesPopup(true);
            try {
                sessionStorage.setItem(
                    templateNoteStorageKeyRef.current,
                    note.slice(0, sliceLastIdx)
                );
            } catch (e) {}
        }
    };

    const handlePopupOnKeyPress = () => {
        if (templateNote.length >= 4000) {
            setTemplateNotesPopup(true);
            closekeyBoard();
        }
    };

    // Order-history "Save as Template": the order-history summary API may return a
    // physician name only (no physicianId). Match that name against the fetched
    // physician list to recover the id so the template save does not fail.
    // This fallback is scoped strictly to the order-history flow.
    const resolveTemplatePhysicianIds = () => {
        // Ignore placeholder empty-string ids (name-only order-history physicians get
        // stored as ['']). Only treat truthy ids as explicitly resolved so the
        // name-matching fallback below can still run for the name-only case.
        const explicitPhysicianIds = (
            templateParams.templateDetails?.physicians || []
        ).filter(Boolean);
        if (isFromOrderHistory) {
            const normalizeName = (value) =>
                String(value || '')
                    .trim()
                    .toLowerCase()
                    .replace(/\s+/g, ' ');
            const matchIdByName = (name) => {
                const target = normalizeName(name);
                if (!target) return null;
                const match = (physicians || []).find((phy) => {
                    const display = normalizeName(phy?.physicianDisplayName);
                    const fullName = normalizeName(
                        `${phy?.physicianFirstName || ''} ${phy?.physicianLastName || ''}`
                    );
                    const formatted = normalizeName(phy?.physicanFormattedName);
                    return (
                        (display && display === target) ||
                        (fullName && fullName === target) ||
                        (formatted &&
                            (formatted === target ||
                                formatted.startsWith(`${target} `)))
                    );
                });
                return match?.physicianId || null;
            };
            // Mirror the name resolution: emit one id per displayed/selected physician
            // (physicianObjectList is the same source used for the names), recovering
            // any name-only physician's id via the fetched physician list. This keeps
            // the physician ids and names in sync when multiple physicians are selected.
            const source = physicianObjectList?.length
                ? physicianObjectList.map((ph) => ({
                    physicianId: ph?.physicianId,
                    name: ph?.physicianDisplayName || ph?.name,
                }))
                : orderTemplateStore?.physiciansSelected || [];
            const ids = source
                .map((ph) => ph?.physicianId || matchIdByName(ph?.name))
                .filter(Boolean);
            if (ids.length) {
                return ids;
            }
            return explicitPhysicianIds;
        }
        return explicitPhysicianIds;
    };

    // Resolve the physician display name(s) so the template save can carry the name
    // even when only a name (no id) is available for an order-history MAST physician.
    const resolveTemplatePhysicianNames = () => {
        const namesFromObjectList = (physicianObjectList || [])
            .map((ph) => ph?.physicianDisplayName || ph?.name)
            .filter(Boolean);
        if (namesFromObjectList.length) {
            return namesFromObjectList.join(',');
        }
        if (isFromOrderHistory && orderTemplateStore?.physiciansSelected?.length) {
            return orderTemplateStore.physiciansSelected
                .map((ph) => ph?.name)
                .filter(Boolean)
                .join(',');
        }
        return physicianFieldText || '';
    };

    const callCreateTemplate = () => {
        if (templateName) {
            const resolvedPhysicianIds = resolveTemplatePhysicianIds();
            const resolvedPhysicianNames = resolveTemplatePhysicianNames();
            let templateRequest = {
                templateDetails: {
                    ...templateParams.templateDetails,
                    templateName: templateName.trim(),
                    addToFavorite: isFavorite,
                    notes: templateNote,
                    accounts:
                        templateParams.templateDetails?.accounts?.join(','),
                    physicians: resolvedPhysicianIds.join(','),
                    physicianName: resolvedPhysicianNames,
                    procedureCode: Procedure,
                    territoryId: !templateMandatoryFields?.expirationField
                        ? selectedTerritoryId === ALLTERRITORIES ? '' : selectedTerritoryId
                        : '',
                    districtId: !templateMandatoryFields?.expirationField
                        ? selectedDistrictId === ALLDISTRICTS ? '' : selectedDistrictId
                        : '',
                    expirationDate: surgeryDate ? surgeryDate : '',
                    templateType:
                        orderTemplateStore.isMastOrder || isMastOrderSurgery
                            ? 'SURGERY_MAST'
                            : 'surgery',
                },
                cartData: {
                    products: getTemplateProducts(),
                },
            };
            dispatch(createTemplate(templateRequest));
        }
    };

    const getTemplateProducts = () => {
        if (
            orderDataStatus.itemProductsCount ||
            orderDataStatus.setProductsCount
        ) {
            let orders = [];
            orderDataStatus.itemProductsCount &&
                orders.push(...orderDataStatus.itemProducts);
            orderDataStatus.setProductsCount &&
                orders.push(...orderDataStatus.setProducts);
            return orders.map((pr) => {
                const product = {
                    productCFN: pr.cfn,
                    salesOrg: pr.salesOrg,
                    quantity: pr?.quantity ? pr.quantity : 1,
                };
                if (pr.bundleItems?.length) {
                    product.bundleItems = pr.bundleItems.map((item) => ({
                        cfn: item.cfn,
                        salesOrg: item.salesOrg,
                        quantity: item?.quantity ? item.quantity : 1,
                    }));
                }
                return product;
            });
        }
        return templateCartProduct.map((it) => {
            const product = {
                productCFN: it.productCFN,
                salesOrg: it.salesOrg,
                quantity: it.quantity,
            };
            if (it.bundleItems?.length) {
                product.bundleItems = it.bundleItems.map((item) => ({
                    cfn: item.cfn ? item.cfn : item.productCFN,
                    salesOrg: item.salesOrg,
                    quantity: item?.quantity ? item.quantity : 1,
                }));
            }
            return product;
        });
    };

    const onDistrictChange = (value) => {
        isDistrictClearedRef.current = !value?.districtId;
        value?.districtId == undefined && (isTerritoryClearedRef.current = true); 
        value?.districtId !== undefined && (isTerritoryClearedRef.current = false); 
        setSelectedDistrict(value?.districtId);
        setSelectedTerritory('');
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                accounts: [],
                physicians: [],
            },
        }));
        setAccountsObjectList([]);
        setPhysicianObjectList([]);
        dispatch(
            clearSingleDropDownList({
                name: 'accounts',
            })
        );
        // dispatch(
        //     getDropdownValues({
        //         dropDownName: 'accounts',
        //         districtId: value?.districtId,
        //     })
        // );
        dispatch(
            clearSingleDropDownList({
                name: 'territories',
            })
        );
        dispatch(
            getDropdownValues({
                dropDownName: 'territories',
                value: value?.districtId === ALLDISTRICTS ? '' : value?.districtId,
            })
        );
        clearBillToAndShipTo();
    };

    const onTerritoryChange = (value) => {
        isTerritoryClearedRef.current = !value?.territoryId;
        setSelectedTerritory(value?.territoryId);
        setAccountsObjectList([]);
        setPhysicianObjectList([]);
        dispatch(
            clearSingleDropDownList({
                name: 'accounts',
            })
        );
        setTemplateParams(prev => ({
            ...prev,
            templateDetails: {
                ...prev.templateDetails,
                accounts: [],
                physicians: [],
            },
        }));
    };

    const showOptionsAfterClose = (value) => {
        setTimeout(() => {
            try {
                handleDisableField(value, true);
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 700);
    };

    const closekeyBoard = () => {
        document.activeElement.blur();
    };

    const getDistrictView = useCallback(() => {
        if (districts?.length > 1) {
            return (
                <Select
                    id="common-index-createTemplate-districtName"
                    value={selectedDistrictId}
                    options={districts}
                    onChange={onDistrictChange}
                    placeholder={t(
                        'consignment.dTerritory.district.placeholder'
                    )}
                    optionValue="districtCode"
                    optionLabel="districtName"
                    name="districtId"
                    onOpen={onOpen}
                    onClose={onClose}
                    itemTemplate={(option) => {
                        if (option) {
                            return (
                                <SelectedCurrentLoc
                                    width={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '240px'
                                            : '100%'
                                    }
                                    whiteSpace={'pre-wrap'}
                                >
                                    {option.districtName}
                                </SelectedCurrentLoc>
                            );
                        }
                    }}
                    valueTemplate={(option, props) => {
                        if (option) {
                            return (
                                <SelectedCurrentLoc
                                    width={
                                        window.innerWidth <= '360'
                                            ? '215px'
                                            : '240px'
                                    }
                                >
                                    {option.districtName}
                                </SelectedCurrentLoc>
                            );
                        }
                        return <div>{props.placeholder}</div>;
                    }}
                />
            );
        }
        return (
            <AccPhysProceValue>
                {
                    getObjectFromArray(
                        districts,
                        'districtCode',
                        districtId || selectedDistrictId
                    )?.districtName
                }
            </AccPhysProceValue>
        );
    }, [districts, selectedDistrictId, districtId, t, onDistrictChange, onOpen, onClose]);

    const getTerritoryView = useCallback(() => {
        if (territories?.length === 1 && !isTerritoryClearedRef.current) {
            return (
                <AccPhysProceValue>
                    {
                        getObjectFromArray(
                            territories,
                            'terrirotryCode',
                            territories?.[0]?.terrirotryCode ||
                            selectedTerritoryId
                        )?.terrirotryName
                    }
                </AccPhysProceValue>
            );
        }
        if (territory && territories?.length > 1 ) {
            return (
                <>
                    <Select
                        id="common-index-createTemplate-terrirotryName"
                        value={
                            selectedTerritoryId ||
                            territory.terrirotryCode ||
                            selectedTerritoryId
                        }
                        options={
                            territories?.length
                                ? territories
                                : territory
                                    ? territory
                                    : []
                        }
                        onChange={onTerritoryChange}
                        placeholder={t(
                            'consignment.dTerritory.territory.placeholder'
                        )}
                        optionValue="terrirotryCode"
                        optionLabel="terrirotryName"
                        name="territoryId"
                        onOpen={onOpen}
                        onClose={onClose}
                        itemTemplate={(option) => {
                            if (option) {
                                return (
                                    <SelectedCurrentLoc
                                        width={
                                            window.innerWidth <=
                                                sizes.mobileDevice
                                                ? '240px'
                                                : '100%'
                                        }
                                        whiteSpace={'pre-wrap'}
                                    >
                                        {option.terrirotryName}
                                    </SelectedCurrentLoc>
                                );
                            }
                        }}
                        valueTemplate={(option, props) => {
                            if (option) {
                                return (
                                    <SelectedCurrentLoc
                                        width={
                                            window.innerWidth <= '360'
                                                ? '215px'
                                                : '240px'
                                        }
                                    >
                                        {option.terrirotryName}
                                    </SelectedCurrentLoc>
                                );
                            }
                            return <>{props.placeholder}</>;
                        }}
                    />
                </>
            );
        }
    }, [territories, selectedTerritoryId, territory, t, onTerritoryChange, onOpen, onClose]);

    const handleDropdownOnScroll = () => {
        setDisableFields({
            ...disableFields,
            account: false,
            physician: false,
        });
        closekeyBoard();
    };

    const getSetCount = () => {
        const setCount = cartProduct.filter((it) => it.isSet).length;
        if (orderDataStatus.setProductsCount) {
            return `${orderDataStatus.setProductsCount} ${
                orderDataStatus.setProductsCount > 1
                    ? t('templates.surgeryTemplate.sets')
                    : t('more.common.templateDetails.set')
                }`;
        }
        if (setCount > 0) {
            return `${setCount} ${
                setCount > 1
                    ? t('templates.surgeryTemplate.sets')
                    : t('more.common.templateDetails.set')
                }`;
        }
        return null;
    };
    const getItemCount = () => {
        const itemCount = cartProduct
            .filter(
                (it) => !it.isSet && removeExtraItem[it.salesOrg] !== 'VISIBLE'
            )
            .reduce((sum, curr) => sum + parseInt(curr.quantity || 0), 0);
        if (orderDataStatus.itemProductsCount) {
            return `${orderDataStatus.itemProductsCount} ${
                orderDataStatus.itemProductsCount > 1
                    ? t('consignment.itemList.items')
                    : t('templates.templatesList.item')
                }`;
        }
        if (itemCount) {
            return `${itemCount} ${
                itemCount > 1
                    ? t('consignment.itemList.items')
                    : t('templates.templatesList.item')
                }`;
        }
        return null;
    };
    const onChangeHandler = (date) => {
        if (!date) {
            setSurgeryDate('');
        } else {
            setSurgeryDate(moment(date).format('YYYY-MM-DD[T]HH:mm:ss[Z]'));
        }
    }; 
    const handleCancelCreateTemplate = () => {
        isExplicitCloseRef.current = true;
        try {
            sessionStorage.removeItem(templateNameStorageKeyRef.current);
            sessionStorage.removeItem(templateNoteStorageKeyRef.current);
        } catch (e) {}
        setTemplateName('');
        setTemplateNote('');
        handleClose(false);
    };
    return (
        <div id={id} style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden' }}>
            <TemplateTitleContainer>
                <TemplateTitle showAstrisk={false}>
                    {t(
                        'ConsignmentAdd.common.bundleItems.createTemplate.templateDetails'
                    )}
                </TemplateTitle>
            </TemplateTitleContainer>

            {createTemplateStore.loading || orderTemplateStore.loading || userDetailsLoading ? (
                <Spinner id="common-index-createTemplate-loadingSpinner" animation="border" variant="primary" small />
            ) : (
                <Suspense fallback={<Spinner id="common-index-createTemplate-loadingSpinner" animation="border" variant="primary" small />}>
                    <CreateTemplateContainer
                        orderTemplateStore={orderTemplateStore}
                        isMastOrderSurgery={isMastOrderSurgery}
                        t={t}
                        getSetCount={getSetCount}
                        getItemCount={getItemCount}
                        templateMandatoryFields={templateMandatoryFields}
                        favoriteOrUnfavorite={favoriteOrUnfavorite}
                        isFavorite={isFavorite}
                        templateName={templateName}
                        handleTemplateName={handleTemplateName}
                        getDistrictView={getDistrictView}
                        getTerritoryView={getTerritoryView}
                        accountsObjectList={accountsObjectList}
                        handleRemoveAccountFromTemplate={handleRemoveAccountFromTemplate}
                        id={id}
                        accountRef={accountRef}
                        filteredAccountList={filteredAccountList}
                        accountValue={accountValue}
                        AccountTemplate={AccountTemplate}
                        handleSearch={handleSearch}
                        handleAddAccountToTemplate={handleAddAccountToTemplate}
                        setDisableFields={setDisableFields}
                        disableFields={disableFields}
                        accountsOptionLoading={accountsOptionLoading}
                        handleOnfocus={handleOnfocus}
                        selectedTerritoryId={selectedTerritoryId}
                        dropdownHeight={dropdownHeight}
                        physicianDropdownSurgeryVisibility={physicianDropdownSurgeryVisibility}
                        VISIBLE={VISIBLE}
                        physicianDropdownZGSurgeryVisibility={physicianDropdownZGSurgeryVisibility}
                        physicianObjectList={physicianObjectList}
                        handleRemovePhysicianFromTemplate={handleRemovePhysicianFromTemplate}
                        physiciantype={physiciantype}
                        physicianTypeChange={physicianTypeChange}
                        salesOrg={salesOrg}
                        countryISOCode={countryISOCode}
                        filteredPhysicianList={filteredPhysicianList}
                        physicianRef={physicianRef}
                        renderNoOption={renderNoOption}
                        handleAddPhysicianToTemplate={handleAddPhysicianToTemplate}
                        setPhysicianValue={setPhysicianValue}
                        physiciansOptionLoading={physiciansOptionLoading}
                        physicianInputValue={physicianInputValue}
                        showOptionsAfterClose={showOptionsAfterClose}
                        physicianTextSurgeryVisibility={physicianTextSurgeryVisibility}
                        physicianTextBoxType={localPhysicianTextBoxType}
                        physicianTextBoxTypeChange={physicianTextBoxTypeChange}
                        physicianFieldText={localPhysicianFieldText}
                        handleInputChange={handleInputChange}
                        surgeryDate={surgeryDate}
                        onChangeHandler={onChangeHandler}
                        date={date}
                        Procedure={Procedure}
                        procedures={procedures}
                        setProcedure={setProcedure}
                        onOpen={onOpen}
                        onClose={onClose}
                        templateNote={templateNote}
                        handleNote={handleNote}
                        textAreaCharLimit={textAreaCharLimit}
                        handlePopupOnKeyPress={handlePopupOnKeyPress}
                        templateNotesPopup={templateNotesPopup}
                        templateNameErrorMsg={templateNameErrorMsg}
                        setTemplateNotesPopup={setTemplateNotesPopup}
                        setTemplateNameErrorMsg={setTemplateNameErrorMsg}
                        showExtraItemNotAvailablePopup={showExtraItemNotAvailablePopup}
                        extraItems={getExtraItemsForPopup()}
                        setShowExtraItemNotAvailablePopup={setShowExtraItemNotAvailablePopup}
                        setDisablePopups={setDisablePopups}
                        handleDropdownOnScroll={handleDropdownOnScroll}
                        // Ship To props
                        shipToValue={shipToValue}
                        shipToInputValue={shipToInputValue}
                        shipToAddressSearchResults={shipToAddressSearchResults}
                        shipToAddressSearchLoading={shipToAddressSearchLoading}
                        openShipToDropdown={openShipToDropdown}
                        setOpenShipToDropdown={setOpenShipToDropdown}
                        handleShipToChange={handleShipToChange}
                        handleShipToInputChange={handleShipToInputChange}
                        setShipToInputValue={setShipToInputValue}
                        getShipToAddressList={getShipToAddressList}
                        // Bill To props
                        billToVisibility={billToVisibility}
                        billToMandatory={billToMandatory}
                        billToDetails={billToDetails}
                        billToDetailsLoading={billToDetailsLoading}
                        billToId={billToId}
                        billToValue={billToValue}
                        handleBillToChange={handleBillToChange}
                        setBillToValue={setBillToValue}
                        getBillToDetailsList={getBillToDetailsList}
                        openBillToDropdown={openBillToDropdown}
                        setOpenBillToDropdown={setOpenBillToDropdown}
                        clearBillToAndShipTo={clearBillToAndShipTo}
                        // Care Of props
                        careOfFieldVisibility={careOfFieldVisibility}
                        careOfFieldMandatory={careOfFieldMandatory}
                        careOfValue={careOfValue}
                        handleCareOfChange={handleCareOfChange}
                        MANDATORY={MANDATORY}
                        shipToVisibility={shipToVisibility}
                        shipToMandatory={shipToMandatory}
                    />
                </Suspense>
            )}
            <FooterContainer>
                <SurgeryFooter
                    customStyle={{
                        padding: isMobileDevice()
                            ? '3px -16px 4px -16px'
                            : '0px -16px 0px -16px',
                        position: 'absolute',
                        width: '100%',
                        inPaddingVertical: '19px 0px 18px 0px',
                    }}
                    selectedItems={
                        !templateMandatoryFields?.expirationField &&
                            templateName &&
                            templateCartProduct?.length > 0 &&
                            templateCartProduct !== extraItems &&
                            selectedDistrictId &&
                            selectedTerritoryId
                            ? 'true'
                            : templateName &&
                                templateCartProduct?.length > 0 &&
                                templateCartProduct !== extraItems
                                ? 'true'
                                : ''
                    }
                    createTemplate={true}
                    callCreateTemplate={callCreateTemplate}
                    cancelCreateTemplate={handleCancelCreateTemplate}
                    smallJustifyContent={'flex-end'}
                    tabletPortraitMargin={'0 45px 0 0'}
                    addIosPadding={true}
                    orderPageMobilePadding={orderPageMobilePadding}
                    footerButtonSize={footerButtonSize}
                    footerButtonMargin={footerButtonMargin}
                />
            </FooterContainer>
        </div>
    );
};

export default CreateTemplate;
